module.exports = __webpack_public_path__ + "static/media/wsymbol_0002_sunny_intervals_big_s1.b455ac3f.png";